export default {
  DEFAULT_API_DAYS: 3, // Default days to query to the API if no filter.
}
